<script setup lang="ts">
/**
 * Mention des conditions au pied du paiement — adhésion (/a), billetterie
 * (/b) et boutique. Karim 2026-09-29 : « au lieu de cliquer pour accepter, on
 * part du principe que c'est accepté et on l'indique », comme la page de don
 * (« En effectuant ce don, vous acceptez nos conditions d'utilisation »).
 *
 * Valider vaut acceptation : plus de case à cocher, et Apple Pay, Google Pay,
 * PayPal et « Payer » ne sont plus bloqués. La preuve reste enregistrée côté
 * serveur (boutique : date et version du PDF des CGV, migration 196).
 */
withDefaults(
  defineProps<{
    /** Un paiement a lieu (faux : inscription gratuite ou demande d'adhésion). */
    paiement?: boolean;
    /** Boutique : l'association a des conditions générales de vente (PDF). */
    conditionsVente?: boolean;
    /** Lien du PDF des CGV de l'association (null : citées sans lien). */
    conditionsVenteUrl?: string | null;
  }>(),
  { paiement: true, conditionsVente: false, conditionsVenteUrl: null },
);

const { t } = useI18n();
</script>

<template>
  <p
    class="mt-5 text-xs leading-relaxed text-center text-[#505870] dark:text-gray-400"
    data-testid="mention-conditions"
  >
    <template v-if="paiement">{{ `${t("association.publicPage.mentionConditions.paiementSecurise")} ` }}</template>
    <i18n-t keypath="association.publicPage.mentionConditions.base" tag="span">
      <template #conditionsUtilisation>
        <a href="/terms" target="_blank" rel="noopener" class="underline hover:no-underline">{{ t("association.publicPage.mentionConditions.conditionsUtilisation") }}</a>
      </template>
      <template #charteConfidentialite>
        <a href="/privacy" target="_blank" rel="noopener" class="underline hover:no-underline">{{ t("association.publicPage.mentionConditions.charteConfidentialite") }}</a>
      </template>
    </i18n-t><template
      v-if="conditionsVente"
    ><i18n-t keypath="association.publicPage.mentionConditions.cgvSuffixe" tag="span">
      <template #conditionsGeneralesDeVente>
        <a
          v-if="conditionsVenteUrl"
          :href="conditionsVenteUrl"
          target="_blank"
          rel="noopener"
          class="underline hover:no-underline"
          data-testid="mention-cgv"
        >{{ t("association.publicPage.mentionConditions.conditionsGeneralesDeVente") }}</a><span v-else data-testid="mention-cgv">{{ t("association.publicPage.mentionConditions.conditionsGeneralesDeVente") }}</span>
      </template>
    </i18n-t></template>.
  </p>
</template>
